
export const regularCrystallisationContent = {
    summaryTitle: "Review",
    amount: "Total tailored drawdown",
    frequency: "Frequency of tailored drawdown",
    date: "Date of next payment",
    pcls: "Regular PCLS",
    income: "Regular income",
    annualIncome: "Annual tailored drawdown",
    confirmationTitle:  "Confirmation",
    cancelButton: "Cancel tailored drawdown",
    lightboxMessage: "Are you sure you want to cancel the tailored drawdown?",
    inProgressWarning: "Pension income due within 5 days. Cancellation will be effective from the next payment date. Are you sure you want to cancel the tailored drawdown?"
}

export const successMessage = (givenName: string, familyName: string) =>  `The tailored drawdown for ${givenName} ${familyName} is now cancelled.`;

